import { useState, useEffect } from 'react'

/**
 * 偵測 LCP 的 Hook
 * @returns {boolean} lcpDetected - LCP 是否已完成
 */
export const useLCPDetector = () => {
  const [lcpDetected, setLcpDetected] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    let observer = null

    // 使用 PerformanceObserver 偵測 LCP
    if ('PerformanceObserver' in window) {
      let lastEntry = null

      observer = new PerformanceObserver((list) => {
        const entries = list.getEntries()
        lastEntry = entries[entries.length - 1]
      })

      try {
        observer.observe({ type: 'largest-contentful-paint', buffered: true })
      } catch (e) {
        console.warn('PerformanceObserver 不支援 LCP 偵測', e)
        if (observer) observer.disconnect()
        // 若瀏覽器不支援則 2.5 秒後設為 true
        setTimeout(() => setLcpDetected(true), 2500)
      }

      // 2.5 秒後檢查是否有 lastEntry 並當作 LCP
      const checkTimer = setTimeout(() => {
        if (lastEntry) {
          setLcpDetected(true)
          if (observer) observer.disconnect()
        }
      }, 2500)

      // Fallback: 如果 5 秒後還沒偵測到，強制設定為 true
      const fallbackTimer = setTimeout(() => {
        setLcpDetected(true)
        if (observer) observer.disconnect()
      }, 5000)

      return () => {
        clearTimeout(checkTimer)
        clearTimeout(fallbackTimer)
        if (observer) observer.disconnect()
      }
    } else {
      // 不支援 PerformanceObserver 的瀏覽器，延遲 2.5 秒
      setTimeout(() => setLcpDetected(true), 2500)
    }
  }, [])

  return lcpDetected
}
